import { z } from "zod";
import { isoDateTimeSchema, uuidSchema } from "./common.js";
const eventBase = {
    name: z.string().trim().min(1, "Name ist Pflicht").max(120),
    startAt: isoDateTimeSchema,
    endAt: isoDateTimeSchema.optional().nullable(),
    location: z.string().trim().min(1, "Ort ist Pflicht").max(120),
    description: z.string().trim().max(2000).optional().nullable(),
};
export const createEventSchema = z.object(eventBase).superRefine((data, ctx) => {
    if (data.endAt && new Date(data.endAt) <= new Date(data.startAt)) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ["endAt"],
            message: "Endzeit muss nach Startzeit liegen",
        });
    }
});
export const updateEventSchema = z
    .object({
    name: eventBase.name.optional(),
    startAt: eventBase.startAt.optional(),
    endAt: eventBase.endAt,
    location: eventBase.location.optional(),
    description: eventBase.description,
})
    .superRefine((data, ctx) => {
    if (data.startAt && data.endAt && new Date(data.endAt) <= new Date(data.startAt)) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ["endAt"],
            message: "Endzeit muss nach Startzeit liegen",
        });
    }
});
export const eventListQuerySchema = z.object({
    upcomingOnly: z.coerce.boolean().default(false),
});
// Re-export uuidSchema as we use it for FlightOffer-eventId in flight-offer.ts
export { uuidSchema };
//# sourceMappingURL=event.js.map